import {Field} from '../types';
import {gpsCoordinateOf} from './deviceLocation';

type FormField = Pick<Field, 'code' | 'type' | 'required' | 'context' | 'fieldType'>;

/** The fields a person fills in on a create form; the others come from the context or from the device. */
export const fieldsToFillIn = <F extends FormField>(fields: F[]): F[] =>
    fields.filter(field => !field.context && !gpsCoordinateOf(field) && field.type !== 'one-to-many');

const isMissing = (value: unknown): boolean => value === undefined || value === null || value === '';

/**
 * Required values a create form takes from where it was opened and that did not
 * come. The form never shows such a field, so nobody can fill them in here.
 */
export const missingContextValues = <F extends FormField>(fields: F[], values: Record<string, any>): F[] =>
    fields.filter(field => field.context && field.required && isMissing(values[field.code]));

/**
 * A create form that shows no field leaves the person nothing to do but press
 * the button, so it saves itself - once the device is done with the position
 * and no required value is missing (the server would refuse such a record).
 */
export const canSaveItself = (fields: FormField[], values: Record<string, any>, locating: boolean): boolean => {
    const stored = fields.filter(field => field.type !== 'one-to-many');

    return !locating
        && stored.length > 0
        && fieldsToFillIn(fields).length === 0
        && stored.every(field => !field.required || !isMissing(values[field.code]));
};
